import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Observable} from 'rxjs';
import {filter, map, tap} from 'rxjs/operators';
import {ComponentCatalogComponent} from '../../component-catalog.decorator';
import {ComponentService} from '../../services/component.service';
import {Headline} from '../../services/markdown-parser.service';

@Component({
  selector: 'cc-component-container',
  templateUrl: './component-container.component.html',
  styleUrls: ['./component-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ComponentContainerComponent implements OnInit {
  component$: Observable<ComponentCatalogComponent | undefined>;
  activeAnchor: string;

  readonly headlines: Headline[] = [];

  constructor(private readonly route: ActivatedRoute, private readonly componentService: ComponentService) {
  }

  ngOnInit() {
    this.component$ = this.route.params.pipe(
      map(({ group, id }) => this.componentService.getComponent(group, id)),
      filter(component => component !== undefined),
      tap(component => this.headlines.push({ text: component.name, depth: 1, anchor: component.id })),
    );
  }
}
